<template>
    <b-form :save-url="addUrl" @success="formSuccess" v-slot="{model, loading}">
        <div class="row">
            <div class="col-12">
                <validated-input class="c-input-white" label="Name*" v-model="model.name"
                                 :rules="{required: true, max:20}" :disabled="loading"/>
            </div>

            <div class="col-12">
                <file-input class="c-file-input" label="Image*" name="Image" v-model="model.team_member_image"
                            :disabled="loading"/>
            </div>

            <div class="col-12">
                <validated-input label="Designation*" v-model="model.designation"
                                 :rules="{required: true, max:35}" :disabled="loading"/>
            </div>

            <div class="col-12">
                <validated-text-area label="Full Description*" v-model="model.full_description"
                                     :rules="{required: true, max:500}" :disabled="loading"/>
            </div>

            <div class="col-12">
                <validated-input type="number" label="Order*" name="Order" v-model="model.order"
                                 :rules="{required: true, min_value:1}" :disabled="loading"/>
            </div>
            <div class="col-12">
                <validated-checkbox label="Enabled" v-model="model.is_enabled"
                                    :rules="{required: false}" :disabled="loading"/>
            </div>
            <div class="col-12 text-right">
                <btn class="trn" size="sm" :loading="loading" color="primary" text="Save"

                     loading-text="Saving..." :disabled="loading"/>
            </div>
        </div>
    </b-form>
</template>

<script>
import urls from '@/data/cms-urls';

export default {
    name : 'AddTeam',

    data () {
        return {
            addUrl : urls.cms.team.addEdit
        };
    },

    methods : {
        formSuccess () {
            this.$notify('Successfully Added Team..!', 'Success',
                {
                    type : 'success'
                }
            );
            this.$emit('success');
        }
    }
};
</script>

<style scoped>

</style>
